import React from "react";
import { useNavigate } from "react-router-dom";
import { UserAvatar } from "./UserAvatar";
import { Users, Play } from "lucide-react";

export function RoomCard({ room }) {
  const navigate = useNavigate();
  const thumb = room.current_video?.thumbnail;
  return (
    <div
      data-testid={`room-card-${room.slug}`}
      onClick={() => navigate(`/watch/${room.slug}`)}
      className="group relative w-[240px] sm:w-[280px] shrink-0 cursor-pointer rounded-lg overflow-hidden bg-[#181818] border border-white/10 transition-all duration-300 hover:scale-[1.04] hover:border-red-600/50 hover:z-10 hover:shadow-2xl hover:shadow-red-900/20"
    >
      <div className="relative aspect-video bg-gradient-to-br from-[#2a2a2a] to-[#111] overflow-hidden">
        {thumb ? (
          <img src={thumb} alt={room.name} className="w-full h-full object-cover" />
        ) : (
          <div className="flex items-center justify-center h-full">
            <Play size={40} className="text-white/20" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        {room.participant_count > 0 && (
          <span className="absolute top-2 left-2 flex items-center gap-1 rounded-full bg-[#E50914] px-2 py-0.5 text-[10px] font-bold uppercase text-white shadow-[0_0_12px_rgba(229,9,20,0.8)]">
            <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" /> Canlı
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="rounded-full bg-white/90 p-3">
            <Play size={22} className="text-black fill-black ml-0.5" />
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-white truncate">{room.name}</h3>
        <p className="text-xs text-gray-500 truncate mt-0.5">
          {room.current_video?.title || room.description || "Henüz video yok"}
        </p>
        <div className="mt-2.5 flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <UserAvatar user={room.host} className="h-5 w-5" />
            <span className="text-xs text-gray-400">@{room.host?.username}</span>
          </div>
          <span className="flex items-center gap-1 text-xs text-gray-400">
            <Users size={12} /> {room.participant_count}
          </span>
        </div>
      </div>
    </div>
  );
}
